import {reactive} from 'vue';

export default function (){
	
	const alert = reactive({
		type: '',
		headline: '',
		message: '',
		// Label of an optional way out offered next to the message; the
		// component emits `alert-action` when it is used.
		action: '',
		isShown: false
	});
	function alertHide(){
		alert.isShown = false;
	}
	function alertShow(){
		alert.isShown = true;
	}
	function alertCreate({type, headline = '', message, action = ''}){
		alert.type = type;
		alert.headline = headline;
		alert.message = message;
		alert.action = action;
	}
	
	return { alert, alertHide, alertShow, alertCreate}
}
